import gql from "graphql-tag";

const getAllWorkShift = gql`
  query(
    $limit: Int
    $page: Int
    $query: String
    $isOvertime: Boolean
    $departmentIds: [ID!]
    $branchLocationId: ID
  ) {
    getAllWorkShift(
      query: $query
      paging: { limit: $limit, page: $page }
      filter: {
        departmentIds: $departmentIds
        branchLocationId: $branchLocationId
      }
      isOvertime: $isOvertime
    ) {
      id
      title
      code
      dayInWeeks
      duration
      startTime
      startBreakTime
      endTime
      endBreakTime
    }
  }
`;

const getAllWorkShiftWithRate = gql`
  query(
    $limit: Int
    $page: Int
    $query: String
    $isOvertime: Boolean
    $departmentIds: [ID!]
    $branchLocationId: ID
  ) {
    getAllWorkShift(
      query: $query
      paging: { limit: $limit, page: $page }
      filter: {
        departmentIds: $departmentIds
        branchLocationId: $branchLocationId
      }
      isOvertime: $isOvertime
    ) {
      id
      title
      code
      dayInWeeks
      workOvertimeRateId
      workOvertimeRate {
        id
        name
        dayInWeeks
        items {
          id
          shift
          startTime
          endTime
          rateWorkingDay
          rateWeekend
          rateHoliday
        }
      }
    }
  }
`;

export default { getAllWorkShift, getAllWorkShiftWithRate };
